import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/empty_img.svg'


const _withScopeId = n => (_pushScopeId("data-v-6928d420"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "square_container" }
const _hoisted_2 = { class: "square_container_img_wrap" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "empty"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "square_meta" }
const _hoisted_8 = { class: "square_meta_title" }
const _hoisted_9 = {
  key: 0,
  class: "square_meta_status"
}
const _hoisted_10 = {
  key: 1,
  class: "square_meta_status"
}
const _hoisted_11 = { class: "square_meta_bottom" }
const _hoisted_12 = { class: "bottom_time" }
const _hoisted_13 = { class: "bottom_number" }
const _hoisted_14 = {
  key: 0,
  class: "square_wrap_tab"
}
const _hoisted_15 = { class: "item_select_arrow" }
const _hoisted_16 = {
  key: 1,
  class: "row"
}
const _hoisted_17 = { class: "row_wrap" }
const _hoisted_18 = { class: "row_wrap_top" }
const _hoisted_19 = { class: "wrap_top_left" }
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 1,
  class: "left_img empty"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 2,
  class: "square_wrap_tab"
}
const _hoisted_25 = { class: "wrap_top_right" }
const _hoisted_26 = { class: "right_title" }
const _hoisted_27 = {
  key: 0,
  class: "square_meta_status"
}
const _hoisted_28 = {
  key: 1,
  class: "square_meta_status"
}
const _hoisted_29 = { class: "row_wrap_bottom" }
const _hoisted_30 = { class: "bottom_time" }
const _hoisted_31 = { class: "bottom_number" }

import LiveTab from '@/components/liveItem/LiveTab.vue';
import { reactive } from 'vue';
import type { RootLive } from './types';
interface IProps {
  dataSource: RootLive;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LiveItem',
  props: {
    dataSource: null
  },
  setup(__props: any) {

const props = __props as {
  dataSource: RootLive;
};


const data = reactive(props.dataSource);
const statusList = [
  {
    icon: 'gateway_notice',
    name: '预告',
  },
  {
    icon: 'gateway_live',
    name: '直播',
  },
  {
    icon: 'gateway_live',
    name: '结束',
  },
  {
    icon: 'gateway_playback',
    name: '回放',
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (data.style !== 1)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "square_wrap",
        style: _normalizeStyle({ border: data.image_player_cover_url ? '' : 'none' })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (data.image_player_cover_url)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "square_container_img",
                  src: data.image_player_cover_url
                }, null, 8, _hoisted_3))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_a_skeleton, {
            loading: !data.title,
            paragraph: { rows: 2 },
            title: false
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, _toDisplayString(data.title), 1)
            ]),
            _: 1
          }, 8, ["loading"]),
          (data.status)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_svg_icon, {
                  "icon-class": statusList[data.status].icon
                }, null, 8, ["icon-class"]),
                _createTextVNode(" " + _toDisplayString(statusList[data.status].name), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10)),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_a_skeleton, {
              loading: !data.title,
              paragraph: { rows: 1 },
              title: false
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_12, _toDisplayString(data.start_at.slice(5)) + " 开播", 1)
              ]),
              _: 1
            }, 8, ["loading"]),
            _createVNode(_component_a_skeleton, {
              loading: !data.title,
              paragraph: { rows: 1 },
              title: false
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, _toDisplayString(data.number) + " 观看", 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ]),
        (data.mode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createVNode(LiveTab, {
                tabType: "mode",
                statusType: data.mode,
                playing: data.live_url_status,
                size: "lg"
              }, null, 8, ["statusType", "playing"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_svg_icon, {
            class: "item_select_arrow_icon",
            "icon-class": "checked"
          })
        ])
      ], 4))
    : (_openBlock(), _createElementBlock("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              (data.image_player_cover_url)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "left_img",
                    src: data.image_player_cover_url
                  }, null, 8, _hoisted_20))
                : (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23)),
              (data.mode)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createVNode(LiveTab, {
                      tabType: "mode",
                      statusType: data.mode,
                      playing: data.live_url_status,
                      size: "lg"
                    }, null, 8, ["statusType", "playing"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_a_skeleton, {
                loading: !data.title,
                paragraph: { rows: 2 },
                title: false
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_26, _toDisplayString(data.title), 1)
                ]),
                _: 1
              }, 8, ["loading"]),
              (data.status)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createVNode(_component_svg_icon, {
                      "icon-class": statusList[data.status].icon
                    }, null, 8, ["icon-class"]),
                    _createTextVNode(" " + _toDisplayString(statusList[data.status].name), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_28)),
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_a_skeleton, {
                  loading: !data.title,
                  paragraph: { rows: 1 },
                  title: false
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_30, _toDisplayString(data.start_at.slice(5)) + " 开播", 1)
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_component_a_skeleton, {
                  loading: !data.title,
                  paragraph: { rows: 1 },
                  title: false
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_31, _toDisplayString(data.number) + " 观看", 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ])
          ])
        ])
      ]))
}
}

})